"use client";
import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import { FcLikePlaceholder, FcLike } from "react-icons/fc";
import { toLiked } from "@/helpers/Functions/liked"
import { Product } from "@/types";
import { useCart } from "@/contexts/CartContext";
import { useLiked } from "@/contexts/LikedContext";
import { useUser } from "@/contexts/UserContext";
import { HiExternalLink } from "react-icons/hi";
import { MdNotifications, MdNotificationsActive } from "react-icons/md";

type Props = {
  product: Product;
  image: Array<string>;
  isSweet?: boolean;
};

const ProductComp = (props: Props) => {
  const [isLiked, setIsLiked] = useState(false);
  const { product, image } = props;
  const { name, englishname, price, category, uniqueid, type } = product;
  const { cart, setCart, locked } = useCart();
  const { liked, setLiked } = useLiked();
  const { signedIn, setSignedIn } = useUser();
  useEffect(() => {
    if (liked.find((item) => item.id === product.id)) {
      setIsLiked(true);
    }
  }, [liked, product.id]);
  return (
    <div className="lg:w-1/4 md:w-1/3 md:mx-0 mx-auto w-full relative h-[360px] max-w-[640px] flex-grow rounded-lg overflow-hidden product-card shadow-sm">
      {
        (props.product.category === "Drink" || props.product.category === "Cold") && (
          <Link className="flex gap-1 items-center justify-center py-2 px-4 z-10 top-4 right-4 w-fit absolute whitespace-nowrap text-center rounded-full bg-amber-500 text-white shadow-sm bg-opacity-80" href={`https://order.online/business/~12620887/`} target="_blank">
            <span>Order Now</span>
            <HiExternalLink size={20} />
          </Link>
        )
      }
      {product.category != 'Drink' && product.category != 'Cold' &&
        product.outofstock == 1 && product.outofstock1kg == 1 && (
          <div className="absolute top-0 left-0 z-10 w-full h-full bg-black bg-opacity-50 flex flex-col items-center justify-center">
            <h2 className="text-white text-2xl font-bold">Out of Stock</h2>
            {/* <button area-label="Notify Me">
              <MdNotificationsActive size={36} className="text-amber-300 hover:text-amber-400 active:text-amber-300" />
            </button> */}
          </div>
        )}
      {/* {
        product.quantity < 10 && product.category != 'Drink' && product.category != 'Cold' && (
          // hurry only {product.quantity} left - Top right corner 
          <div className="absolute top-0 right-0 z-10 bg-amber-500 text-white p-2 rounded-bl-lg rounded-tr-lg">
            <p className="text-sm">Hurry! Only {product.quantity} left</p>
          </div>
        )
      } */}
      <Link href={`\products\/${uniqueid}`}>
        <Image
          className="object-center object-cover min-w-full h-full overflow-hidden hover:transform hover:scale-110 transition duration-300 ease-in-out"
          alt={name}
          src={image[0]}
          width={500}
          height={500}
        />
      </Link>
      <div className="z-0 absolute bottom-0 bg-gradient-to-t pt-4 from-black to-transparent w-full flex gap-4 items-end justify-between overflow-hidden">
        <Link href={`/products/${uniqueid}?products=${product.id}`} className="flex flex-col min-w-1/2 w-full p-4">
          <h3 className="text-gray-100 text-sm tracking-widest title-font mb-1">
            {category === "Premix" ? `${category} (${type})` : category}
          </h3>
          <h2 className="text-white title-font text-xl font-medium">{name}</h2>
          <h4 className="text-gray-100 text-sm tracking-widest title-font mb-1">
            {englishname}
          </h4>
          {
            (category != "Drink" && category != "Cold") && <p className="mt-1 text-gray-100">${price}</p>
          }
        </Link>
        <div className="flex flex-col justify-center items-end h-fit gap-4 p-4 py-10">

          {isLiked ? (
            <FcLike
              className="hover:cursor-pointer"
              size={32}
              color="white"
              onClick={() => {
                toLiked(product, liked, setLiked);
                setIsLiked(false);
              }}
            />
          ) : (
            <FcLikePlaceholder
              className="hover:cursor-pointer"
              size={32}
              color="white"
              onClick={() => {
                toLiked(product, liked, setLiked);
                setIsLiked(true);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductComp;
